import { render, staticRenderFns } from "./ExamTablePanel.vue?vue&type=template&id=5e61fa9c&scoped=true&"
import script from "./ExamTablePanel.vue?vue&type=script&lang=js&"
export * from "./ExamTablePanel.vue?vue&type=script&lang=js&"
import style0 from "./ExamTablePanel.vue?vue&type=style&index=0&id=5e61fa9c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e61fa9c",
  null
  
)

export default component.exports